import React, { useState } from 'react';
import { docDisplayName } from '../../lib/linkDisplay.js';
import { DocGlyph } from './LinkGlyphs.jsx';

async function deleteDoc(id) {
  const res = await fetch(`/docs/${id}`, {
    method:      'DELETE',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
      'Accept':       'application/json'
    }
  });
  if (res.status === 401) { window.location = '/session/new'; return false; }
  if (res.status === 403) {
    window.alert("You don't have permission — only the author or a project manager can delete this doc.");
    return false;
  }
  if (!res.ok && res.status !== 204) throw new Error(`DELETE failed (${res.status})`);
  return true;
}

export default function DocItem({ doc, onDeleted }) {
  const [hover, setHover] = useState(false);
  const [busy, setBusy]   = useState(false);

  const name = doc.title && doc.title.trim() ? doc.title.trim() : docDisplayName(doc.url);

  async function destroy(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm('Delete this doc?')) return;
    setBusy(true);
    try {
      const ok = await deleteDoc(doc.id);
      if (ok) onDeleted(doc.id);
    } finally {
      setBusy(false);
    }
  }

  return (
    <a
      href={doc.url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="flex items-center justify-between py-2.5 px-3 rounded-md border hover:bg-[#FBFBF8]"
      style={{ borderColor: '#F0EFE9', background: '#fff', textDecoration: 'none' }}
    >
      <span className="flex items-center gap-2 min-w-0">
        <span style={{ color: '#8A897F', display: 'inline-flex', flexShrink: 0 }}><DocGlyph /></span>
        <span className="text-[13px] truncate" style={{ color: '#1A1A1A' }}>{name}</span>
      </span>
      <button
        type="button"
        onClick={destroy}
        aria-label={`Delete ${name}`}
        style={{
          background: 'none', border: 'none', color: '#9B1F26',
          fontSize: 11, cursor: 'pointer', padding: '2px 6px', flexShrink: 0,
          visibility: (hover && !busy) ? 'visible' : 'hidden'
        }}
      >Delete</button>
    </a>
  );
}
